import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthProvider } from './context/AuthContext.js'
import AppProviders from './AppProviders'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// Auto-recover from chunk load errors when new builds are deployed
window.addEventListener('error', (event) => {
  const isChunkError =
    event?.message &&
    (/Loading chunk [\d]+ failed/i.test(event.message) ||
     /ChunkLoadError/i.test(event.message) ||
     (/Unexpected token '<'/i.test(event.message) && (event.filename || '').includes('.chunk.js')));

  if (isChunkError) {
    const chunkReloadKey = 'chunk_reload_retry';
    const lastReload = sessionStorage.getItem(chunkReloadKey);
    const now = Date.now();
    if (!lastReload || now - Number(lastReload) > 10000) {
      sessionStorage.setItem(chunkReloadKey, String(now));
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppProviders>
        <>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={2500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </>
      </AppProviders>
    </AuthProvider>
  </React.StrictMode>
)
